import React, { useRef, useState } from 'react';
import Card from './Card';
import { uuid } from '../utils';
import Slider from 'infinite-react-carousel';

const Category = ({ category, openModal }) => {
  const catRef = useRef(null);

  const cardType = (cardNum) => {
    return cardNum % 2 === 0 ? 'up' : 'down';
  };

  const [settings, changeSettings] = useState({
    slidesToShow: (() => {
      if (window.innerWidth >= 1250) {
        return 4;
      } else if (window.innerWidth < 1250 && window.innerWidth >= 950) {
        return 3;
      } else if (window.innerWidth < 950 && window.innerWidth >= 550) {
        return 2;
      } else if (window.innerWidth < 550) {
        return 1;
      }
    })(),
    arrows: (() => {
      return window.innerWidth <= 768 ? false : true;
    })(),
    arrowsScroll: 2,
    adaptiveHeight: true,
    className: 'carousel-inner',
    onResize() {
      if (window.innerWidth >= 1250) {
        changeSettings({ ...settings, slidesToShow: 4 });
      } else if (window.innerWidth < 1250 && window.innerWidth >= 950) {
        changeSettings({ ...settings, slidesToShow: 3 });
      } else if (window.innerWidth < 950 && window.innerWidth >= 550) {
        console.log('less then 950');
        changeSettings({ ...settings, slidesToShow: 2 });
      } else if (window.innerWidth < 550) {
        changeSettings({ ...settings, slidesToShow: 1 });
      }

      if (window.innerWidth <= 768) {
        changeSettings({ ...settings, arrows: false });
      } else {
        changeSettings({ ...settings, arrows: true });
      }
    },
  });

  return (
    <section className="category">
      <div className="category-inner" ref={catRef}>
        <Slider {...settings}>
          {category.cards.map((card, i) => (
            <Card
              key={uuid()}
              type={cardType(i + 1)}
              small={card.small}
              special={i === 3}
              card={card}
              openModal={openModal}
            />
          ))}
          {category.cards.length % 2 !== 0 && (
            <Card
              key={uuid()}
              type="up"
              small={
                category.cards[Math.floor(category.cards.length / 2)].small
              }
              special={false}
              card={category.cards[Math.floor(category.cards.length / 2)]}
              openModal={openModal}
            />
          )}
        </Slider>
      </div>
    </section>
  );
};

export default Category;
